import { render, staticRenderFns } from "./shift-receipt.vue?vue&type=template&id=18d1d773"
import script from "./shift-receipt.vue?vue&type=script&lang=js"
export * from "./shift-receipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports